import React, { useState, useEffect } from 'react';
import { 
  FaHospital, 
  FaPhoneAlt, 
  FaMapMarkerAlt, 
  FaEnvelope,
  FaFacebook, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedin,
  FaYoutube,
  FaWhatsapp,
  FaHeartbeat,
  FaAppleAlt,
  FaBookMedical,
  FaShoppingCart,
  FaHeart,
  FaShieldAlt,
  FaUserMd,
  FaChevronDown,
  FaChevronUp,
  FaHome,
  FaStethoscope,
  FaPills,
  FaClipboardList,
  FaFileMedical,
  FaGlobe,
  FaTiktok,
  FaPinterest,
  FaTelegram,
  FaSnapchat,
  FaReddit
} from 'react-icons/fa';
import { database } from '../firebase';
import { ref as dbRef, onValue } from 'firebase/database';
import logo from '../asstes/logo.png'

const Footer = () => {
  const [openSections, setOpenSections] = useState({});
  const [contactData, setContactData] = useState({
    location: '',
    emergencyContact: '',
    phoneNumber: '',
    emailSupport: '',
    generalEmail: '',
    whatsappNumber: '',
    workingHours: '',
    socialLinks: []
  });
  const [loading, setLoading] = useState(true);

  // Fetch contact data from Firebase
  useEffect(() => {
    const contactRef = dbRef(database, 'Dr/contact');
    const unsubscribe = onValue(contactRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setContactData({
          location: data.location || '',
          emergencyContact: data.emergencyContact || '',
          phoneNumber: data.phoneNumber || '',
          emailSupport: data.emailSupport || '',
          generalEmail: data.generalEmail || '',
          whatsappNumber: data.whatsappNumber || '',
          workingHours: data.workingHours || '',
          socialLinks: data.socialLinks || []
        });
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Toggle mobile sections
  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Get social icon
  const getSocialIcon = (platform) => {
    const iconMap = {
      'Facebook': <FaFacebook />,
      'Instagram': <FaInstagram />,
      'Twitter': <FaTwitter />,
      'LinkedIn': <FaLinkedin />,
      'WhatsApp': <FaWhatsapp />,
      'YouTube': <FaYoutube />,
      'TikTok': <FaTiktok />,
      'Pinterest': <FaPinterest />,
      'Telegram': <FaTelegram />,
      'Snapchat': <FaSnapchat />,
      'Reddit': <FaReddit />
    };
    return iconMap[platform] || <FaGlobe />;
  };

  // Get social color
  const getSocialColor = (platform) => {
    const colorMap = {
      'Facebook': 'hover:text-blue-500 hover:bg-blue-900/20',
      'Instagram': 'hover:text-pink-500 hover:bg-pink-900/20',
      'Twitter': 'hover:text-blue-400 hover:bg-blue-800/20',
      'LinkedIn': 'hover:text-blue-600 hover:bg-blue-900/20',
      'WhatsApp': 'hover:text-green-500 hover:bg-green-900/20',
      'YouTube': 'hover:text-red-500 hover:bg-red-900/20',
      'TikTok': 'hover:text-gray-900 hover:bg-gray-900/20',
      'Pinterest': 'hover:text-red-600 hover:bg-red-900/20',
      'Telegram': 'hover:text-blue-500 hover:bg-blue-900/20',
      'Snapchat': 'hover:text-yellow-400 hover:bg-yellow-900/20',
      'Reddit': 'hover:text-orange-600 hover:bg-orange-900/20'
    };
    return colorMap[platform] || 'hover:text-gray-600 hover:bg-gray-900/20';
  };

  // Dynamic contact info based on Firebase data
  const getContactInfo = () => {
    const info = [];
    
    if (contactData.phoneNumber) {
      info.push({
        id: 1,
        icon: <FaPhoneAlt />,
        text: contactData.phoneNumber,
        desc: "Phone"
      });
    }
    
    if (contactData.emergencyContact) {
      info.push({
        id: 2,
        icon: <FaPhoneAlt />,
        text: contactData.emergencyContact,
        desc: "Emergency"
      });
    }
    
    if (contactData.location) {
      info.push({
        id: 3,
        icon: <FaMapMarkerAlt />,
        text: contactData.location,
        desc: "Location"
      });
    }
    
    if (contactData.emailSupport) {
      info.push({
        id: 4,
        icon: <FaEnvelope />,
        text: contactData.emailSupport,
        desc: "Email Support"
      });
    }
    
    // Fallback to hardcoded data if no Firebase data
    if (info.length === 0) {
      return [
        { id: 1, icon: <FaPhoneAlt />, text: "+91 1800 123 4567", desc: "Toll Free" },
        { id: 2, icon: <FaPhoneAlt />, text: "+91 98765 43210", desc: "Emergency" },
        { id: 3, icon: <FaMapMarkerAlt />, text: "Healthcare City, Mumbai", desc: "Head Office" },
        { id: 4, icon: <FaEnvelope />, text: "support@Anusaya.com", desc: "Email Support" }
      ];
    }
    
    return info;
  };

  // Dynamic social media based on Firebase data
  const getSocialMedia = () => {
    if (contactData.socialLinks && contactData.socialLinks.length > 0) {
      return contactData.socialLinks.map((social, index) => ({
        id: index + 1,
        name: social.platform,
        icon: getSocialIcon(social.platform),
        link: social.url,
        color: getSocialColor(social.platform)
      }));
    }
    
  };

  // Quick links data
  const quickLinks = [
    { id: 1, name: "Home", icon: <FaShoppingCart />, link: "/" },
    { id: 2, name: "Hospital Services", icon: <FaHospital />, link: "/hospital" },
    { id: 3, name: "Diet Plans", icon: <FaAppleAlt />, link: "/diet-plans" },
    { id: 4, name: "E-Books", icon: <FaBookMedical />, link: "/ebooks" },
    { id: 5, name: "About Us", icon: <FaUserMd />, link: "/about" },
    { id: 6, name: "Contact Us", icon: <FaPhoneAlt />, link: "/contact" }
  ];

  // Services data
  const services = [
    { id: 1, name: "Online Pharmacy", icon: <FaPills /> },
    { id: 2, name: "Doctor Consultation", icon: <FaStethoscope /> },
    { id: 3, name: "Health Checkup", icon: <FaFileMedical /> },
    { id: 4, name: "Emergency Care", icon: <FaHospital /> },
    { id: 5, name: "Diet Planning", icon: <FaClipboardList /> },
    { id: 6, name: "Medical Store", icon: <FaHome /> }
  ];

  if (loading) {
    return (
      <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white w-full">
        <div className="py-8 px-4">
          <div className="max-w-7xl mx-auto text-center">
            <div className="animate-pulse">
              <p className="text-gray-400">Loading footer information...</p>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white w-full">
      {/* Top Section */}
      <div className="pt-8 pb-8 px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Mobile - Accordion Layout */}
          <div className="lg:hidden space-y-4">
            {/* Brand Section - Always visible on mobile */}
            <div className="bg-gray-800/50 rounded-xl p-4">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  <div className="bg-white p-2 rounded-lg mr-3">
                    <img src={logo} alt="Anusaya Logo" className="h-8 w-8 object-contain" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold">Anusaya</h3>
                    <p className="text-teal-200 text-xs">Complete Healthcare Solution</p>
                  </div>
                </div>
              </div>
              
              <p className="text-gray-400 text-sm mb-4">
                Your trusted partner for comprehensive healthcare services, products, and expert guidance.
              </p>
              
              {/* Social Media - Mobile */}
              <div>
                <h4 className="font-bold mb-3 text-sm">Follow Us</h4>
                <div className="flex justify-center gap-2">
                  {getSocialMedia().slice(0, 4).map((social) => (
                    <a
                      key={social.id}
                      href={social.link}
                      className={`bg-gray-800 hover:bg-gray-700 p-2 rounded-lg transition-all ${social.color}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.name}
                    >
                      <div className="text-lg">
                        {social.icon}
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Quick Links - Accordion */}
            <div className="bg-gray-800/50 rounded-xl overflow-hidden">
              <button
                onClick={() => toggleSection('quickLinks')}
                className="w-full flex items-center justify-between p-4 text-left"
              >
                <div className="flex items-center">
                  <FaHeart className="text-red-400 mr-3" />
                  <h4 className="font-bold">Quick Links</h4>
                </div>
                {openSections.quickLinks ? <FaChevronUp /> : <FaChevronDown />}
              </button>
              
              {openSections.quickLinks && (
                <div className="px-4 pb-4">
                  <ul className="space-y-2">
                    {quickLinks.map((link) => (
                      <li key={link.id}>
                        <a 
                          href={link.link} 
                          className="text-gray-400 hover:text-white transition flex items-center py-2"
                        >
                          <span className="mr-3 text-teal-400">{link.icon}</span>
                          <span>{link.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Services - Accordion */}
            <div className="bg-gray-800/50 rounded-xl overflow-hidden">
              <button
                onClick={() => toggleSection('services')}
                className="w-full flex items-center justify-between p-4 text-left"
              >
                <div className="flex items-center">
                  <FaShieldAlt className="text-blue-400 mr-3" />
                  <h4 className="font-bold">Services</h4>
                </div>
                {openSections.services ? <FaChevronUp /> : <FaChevronDown />}
              </button>
              
              {openSections.services && (
                <div className="px-4 pb-4">
                  <ul className="space-y-2">
                    {services.map((service) => (
                      <li key={service.id}>
                        <a 
                          // href="#" 
                          className="text-gray-400 hover:text-white transition flex items-center py-2"
                        >
                          <span className="mr-3 text-emerald-400">{service.icon}</span>
                          <span>{service.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Contact Info - Accordion */}
            <div className="bg-gray-800/50 rounded-xl overflow-hidden">
              <button
                onClick={() => toggleSection('contact')}
                className="w-full flex items-center justify-between p-4 text-left"
              >
                <div className="flex items-center">
                  <FaMapMarkerAlt className="text-orange-400 mr-3" />
                  <h4 className="font-bold">Contact Info</h4>
                </div>
                {openSections.contact ? <FaChevronUp /> : <FaChevronDown />}
              </button>
              
              {openSections.contact && (
                <div className="px-4 pb-4 space-y-3">
                  {getContactInfo().map((info) => (
                    <div key={info.id} className="flex items-center">
                      <div className="bg-gray-800 p-2 rounded-lg mr-3">
                        <div className="text-teal-400">
                          {info.icon}
                        </div>
                      </div>
                      <div>
                        <p className="font-medium text-sm">{info.text}</p>
                        <p className="text-gray-400 text-xs">{info.desc}</p>
                      </div>
                    </div>
                  ))}
                  
                  {/* Newsletter - Mobile */}
                  <div className="mt-4 pt-4 border-t border-gray-700">
                    <h5 className="font-bold mb-2 text-sm">Subscribe to Newsletter</h5>
                    <div className="flex">
                      <input
                        type="email"
                        placeholder="Your email"
                        className="bg-gray-800 text-white px-3 py-2 rounded-l-lg focus:outline-none focus:ring-1 focus:ring-teal-500 flex-grow text-sm"
                      />
                      <button className="bg-gradient-to-r from-teal-500 to-emerald-500 px-3 py-2 rounded-r-lg hover:opacity-90 transition-opacity text-sm">
                        Subscribe
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Desktop - Grid Layout */}
          <div className="hidden lg:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand Section */}
            <div>
              <div className="flex items-center mb-6">
                <div className="bg-white p-3 rounded-xl mr-4">
                  <img src={logo} alt="Anusaya Logo" className="h-12 w-12 object-contain" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold">Anusaya</h3>
                  <p className="text-teal-200 text-sm">Complete Healthcare Solution</p>
                </div>
              </div>
              <p className="text-gray-400 mb-6 text-sm">
                Your trusted partner for comprehensive healthcare services, products, and expert guidance. 
                We provide complete healthcare solutions for your wellness needs.
              </p>
              
              {/* Social Media Icons */}
              <div className="mb-6">
                <h4 className="text-lg font-bold mb-4">Follow Us</h4>
                <div className="flex flex-wrap gap-3">
                  {getSocialMedia().map((social) => (
                    <a
                      key={social.id}
                      href={social.link}
                      className={`bg-gray-800 hover:bg-gray-700 p-3 rounded-lg transition-all duration-300 ${social.color} transform hover:-translate-y-1`}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.name}
                    >
                      <div className="text-xl">
                        {social.icon}
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-bold mb-6 flex items-center">
                <FaHeart className="text-red-400 mr-2" /> Quick Links
              </h4>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.id}>
                    <a 
                      href={link.link} 
                      className="text-gray-400 hover:text-white transition flex items-center group"
                    >
                      <span className="mr-3 text-teal-400 transition-transform group-hover:scale-110">{link.icon}</span>
                      <span className="group-hover:translate-x-2 transition-transform duration-300">{link.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Services */}
            <div>
              <h4 className="text-lg font-bold mb-6 flex items-center">
                <FaShieldAlt className="text-blue-400 mr-2" /> Services
              </h4>
              <ul className="space-y-3">
                {services.map((service) => (
                  <li key={service.id}>
                    <a 
                      href="#" 
                      className="text-gray-400 hover:text-white transition flex items-center group"
                    >
                      <span className="mr-3 text-emerald-400 transition-transform group-hover:scale-110">{service.icon}</span>
                      <span className="group-hover:translate-x-2 transition-transform duration-300">{service.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-bold mb-6 flex items-center">
                <FaMapMarkerAlt className="text-orange-400 mr-2" /> Contact Info
              </h4>
              <div className="space-y-4">
                {getContactInfo().map((info) => (
                  <div key={info.id} className="flex items-start">
                    <div className="bg-gray-800 p-2 rounded-lg mr-3 mt-1">
                      <div className="text-teal-400">
                        {info.icon}
                      </div>
                    </div>
                    <div>
                      <p className="font-medium">{info.text}</p>
                      <p className="text-gray-400 text-sm">{info.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Newsletter Subscription */}
              <div className="mt-8">
                <h5 className="font-bold mb-3 text-sm">Subscribe to Newsletter</h5>
                <div className="flex">
                  <input
                    type="email"
                    placeholder="Your email"
                    className="bg-gray-800 text-white px-4 py-2 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-teal-500 flex-grow text-sm"
                  />
                  <button className="bg-gradient-to-r from-teal-500 to-emerald-500 px-4 py-2 rounded-r-lg hover:opacity-90 transition-opacity text-sm">
                    Subscribe
                  </button>
                </div>
                <p className="text-gray-500 text-xs mt-2">
                  Get health tips and updates
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-gray-800 py-4 md:py-6 px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-xs sm:text-sm">
                © 2024 Anusaya Platform. All rights reserved.
              </p>
              <p className="text-gray-500 text-xs mt-1">
                <FaShieldAlt className="inline mr-1" /> 
                Your health and privacy are our priority
              </p>
            </div>
            
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6">
              <a href="/privacy-policy" className="text-gray-400 hover:text-white transition text-xs sm:text-sm">Privacy Policy</a>
              <span className="text-gray-600">•</span>
              <a href="/terms-of-service" className="text-gray-400 hover:text-white transition text-xs sm:text-sm">Terms of Service</a>
              <span className="text-gray-600">•</span>
              <a href="/cookie-policy" className="text-gray-400 hover:text-white transition text-xs sm:text-sm">Cookie Policy</a>
              <span className="text-gray-600">•</span>
            </div>
          </div>
        </div>
      </div>

      {/* Emergency Notice - Mobile */}
      <div className="lg:hidden bg-gradient-to-r from-red-900/40 to-red-800/40 border-t border-red-800/50 py-3 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center">
            <FaHospital className="text-red-400 mr-2 text-sm" />
            <p className="text-xs text-center">
              <span className="font-bold">Emergency:</span> Call{" "}
              <span className="font-bold text-red-300">102</span> immediately
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;